<button [disabled]="loading || disabled" class="button" (click)="click()">
  <app-spinner *ngIf="loading"></app-spinner>
  <span *ngIf="!loading">
    {{ text }}
  </span>
</button>
